import { NoteColor } from '../../types'

interface NoteColorStyle {
  value: NoteColor
  label: string
  /** Fondo suave de la nota. */
  bg: string
  /** Borde lateral de color. */
  border: string
  /** Punto indicador. */
  dot: string
  /** Muestra sólida para el selector. */
  swatch: string
}

/**
 * Paleta de colores de las notas internas. Tonos suaves para mantener
 * siempre la legibilidad del texto.
 */
export const NOTE_COLORS: NoteColorStyle[] = [
  {
    value: 'gray',
    label: 'Gris',
    bg: 'bg-slate-50',
    border: 'border-l-slate-300',
    dot: 'bg-slate-400',
    swatch: '#94A3B8',
  },
  {
    value: 'blue',
    label: 'Azul',
    bg: 'bg-blue-50',
    border: 'border-l-blue-400',
    dot: 'bg-blue-500',
    swatch: '#3D8BFF',
  },
  {
    value: 'green',
    label: 'Verde',
    bg: 'bg-green-50',
    border: 'border-l-green-400',
    dot: 'bg-green-500',
    swatch: '#16A34A',
  },
  {
    value: 'red',
    label: 'Rojo',
    bg: 'bg-red-50',
    border: 'border-l-red-400',
    dot: 'bg-red-500',
    swatch: '#DC2626',
  },
]

export function noteColor(color?: NoteColor): NoteColorStyle {
  return NOTE_COLORS.find((c) => c.value === color) ?? NOTE_COLORS[0]
}
